import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this._handleKeyDownBound = this._handleKeyDown.bind(this);
    document.addEventListener('keydown', this._handleKeyDownBound);
  }

  disconnect() {
    document.removeEventListener('keydown', this._handleKeyDownBound);
  }

  zoom(event) {
    const overlay = this._createOverlay();
    const popup = this._createPopup();
    const zoomedImage = this._createZoomedImage(event.currentTarget.src);

    popup.appendChild(zoomedImage);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
  }

  _createOverlay() {
    const overlay = document.createElement('div');
    overlay.classList.add('image-zoom-overlay');
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        this._closeOverlay(overlay);
      }
    });
    return overlay;
  }

  _createPopup() {
    const popup = document.createElement('div');
    popup.classList.add('image-zoom-popup');
    return popup;
  }

  _createZoomedImage(src) {
    const zoomedImage = document.createElement('img');
    zoomedImage.classList.add('image-zoom-image');
    zoomedImage.src = src;
    return zoomedImage;
  }

  _handleKeyDown(event) {
    if (event.key === 'Escape') {
      const overlay = document.querySelector('.image-zoom-overlay');
      if (overlay) {
        this._closeOverlay(overlay);
      }
    }
  }

  _closeOverlay(overlay) {
    overlay.classList.add('closing');
    const image = overlay.querySelector('.image-zoom-image');
    if (image) {
      image.classList.add('closing');
    }
    setTimeout(() => overlay.remove(), 100);
  }
}
